import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const TestimonialsContent = dynamic(() => import('../components/static/testimonials'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
import { fetchTestimonies } from '../api/testimony';
const HeadContent = dynamic(() => import('../hoc/headContent'), { loading: () => <></>, ssr: true });


function Testimonials(props) {
	const meta = {
		title: "Testimonials | Bayan",
		description: "Hear From Current Bayan Students and Alumni.",
		route: "testimonials",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<TestimonialsContent router={props.router} testimonies={props.testimonies}/>
			</Layout>
		</>
	);
}

export async function getStaticProps() {
	// You can use any data fetching library
	const testimonies = await fetchTestimonies();

	return {
		props: {
			testimonies,
		},
		// revalidate: 5 * 60, // seconds
	}
}

export default withRouter(Testimonials);
